import { useMemo } from 'react'
import { useTranslations } from 'next-intl'

export const useLocaleMonths = () => {
  const t = useTranslations('datePicker')
  return useMemo(() => {
    const localizeMonths = t.raw('months')
    return Object.keys(localizeMonths).map((el: string) => localizeMonths[el])
  }, [t])
}

export const useWeekdaysLong = () => {
  const t = useTranslations('datePicker')
  return useMemo(() => {
    const localizeMonths = t.raw('weekdaysLong')
    return Object.keys(localizeMonths).map((el: string) => localizeMonths[el])
  }, [t])
}

export const useWeekdaysShort = () => {
  const t = useTranslations('datePicker')
  return useMemo(() => {
    const localizeMonths = t.raw('weekdaysShort')
    return Object.keys(localizeMonths).map((el: string) => localizeMonths[el])
  }, [t])
}
